import * as React from 'react';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import {Button, ButtonGroup} from 'reactstrap';
import Panel from '../../../theme/components/Panel';
import validate from './validate';
import renderSelectField from '../../../theme/components/form/Select';
import {error} from '../../../utils/notification-actions';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import MiranaServiceClient from '../../../middleware/mirana-client';

interface CoberturasFormState {
    periodos: string[];
}

class CoberturasForm extends React.PureComponent<InjectedFormProps & ReduxProps, CoberturasFormState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);

        this.state = {
            periodos: []
        };

        this.fetchPeriodos();
    };

    private async fetchPeriodos() {
        try {
            const response = await this.apiClient.obtenerPeriodosCoberturas();
            this.setState({periodos: response});
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error al obtener periodos'));
        }
    }

    public render() {
        const {handleSubmit} = this.props;

        return (
            <Panel xs={12} md={12} divider={true} title='Filtros'>
                <form className='form' onSubmit={handleSubmit}>
                    <div className='form__form-group'>
                        <label className='form__form-group-label'>Periodo </label>
                        <div className='form__form-group-field'>
                            <Field
                                name='periodo'
                                component={renderSelectField}
                                placeholder='Seleccione'
                                type='text'
                                options={this.state.periodos.map((per) => {
                                    return {value: per, label: per}
                                })}
                            />
                        </div>
                    </div>
                    <ButtonGroup className='btn-group--justified'>
                        <Button color='success' type='submit'>FILTRAR</Button>
                    </ButtonGroup>
                </form>
            </Panel>
        )
    }
}

export default reduxForm({
    form: 'coberturas_form', // a unique identifier for this form
    validate,
})(CoberturasForm);



// WEBPACK FOOTER //
// ./src/components/pages/coberturas/coberturas-form.tsx